
























































































import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Choices from "../../store/modules/Choices";
import Decisions from "@/store/modules/Decisions";

const workspaceOptions = getModule(WorkspaceOptions)
const choicesModule = getModule(Choices)
const decisionsModule = getModule(Decisions)
@Component({
    components: {}
})
export default class ChoiceVisibilitySelectorMenu extends Vue {

    get choiceList(): any[] {
        return choicesModule.choicesList;
    }

    get visibilityMap() {
        return workspaceOptions.choiceVisibility;
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    private updateVisibility(choiceId: string, value: any) {
        workspaceOptions.changeChoiceVisibility({id: choiceId, value: value});
    }

}
